import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/components/common/api';
import { Company } from '../../../models/company.model';
import { User, UserApplication } from '../../../models/user.model';
import { DataTableCustomButton } from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { CalendarTranslateService } from '../../../modules/UIKit/services/calendarTranslate.service';
import { CompaniesService } from '../../../services/company/companies.service';
import { UsersService } from '../../../services/user/users.service';
import { RoleMSService } from '../../../services/utils/roleMS.service';
import * as moment from 'moment';

@Component({
  selector: 'app-user-applications',
  templateUrl: './userApplication.component.html',
  styles: ['label.required:after {top: 0}']
})

export class UserApplicationComponent implements OnChanges, OnInit {

  @Output() onBackPressed: EventEmitter<any> = new EventEmitter<any>();
  @Input() selectedApplications: UserApplication[];
  @Input() activeUser: User;
  @Input() selectedCompany: Company; // quando inizializzo tramite User Company
  @Input() showRolesButton: boolean;
  @Input() fromUser = false;
  @Input() companyId: number; // quando inizializzo direttamente da User

  dialogApplications: any;
  companies: SelectItem[];
  applications: SelectItem[] = [{ value: null, label: '' }];
  selectedApplicationsClone = [];
  selectedApplicationsSource = [];
  form: FormGroup;
  minDate: Date;
  customButtons: DataTableCustomButton[];
  newDataAvailable = false;
  showDialog = false;
  showRolesDialog = false;
  userApplicationsTitles: DataTableField[];
  userApplicationsGroupBy: DataTableField;
  invalidSubmit: boolean;
  fields: any;
  dialogTitlesList: any = {};
  dialogTitle: string;
  rolesManagementTranslation: string;
  rolesDialogTitle: string;
  rolesForUserApp: any[] = [];
  activeRolesForUserApp: any[] = [];
  selectedApplicationBaseUrl: string;

  public maxDate: Date = new Date();
  dateStartIssue = false;
  dateEndIssue = false;
  dateStartMax = null;
  dateEndMin = null;
  btntraduction = 'common.add';

  defaultDateStart: Date;
  defaultDateEnd: Date;

  constructor(
    private fb: FormBuilder,
    private srvUser: UsersService,
    // private srvTranslate: TranslateService,
    private srvCompany: CompaniesService,
    protected srvCalTranslate: CalendarTranslateService,
    // private srvDate: DateService,
    private translate: TranslateService,
    public srvRoleMS: RoleMSService) {

  }

  ngOnInit(): void {
    this.translate.get([
      'users.add_application_title',
      'users.edit_application_title',
      'common.rolesManagement'
    ])
    .subscribe(res => {
      this.dialogTitlesList.add_title = res['users.add_application_title' ];
      this.dialogTitlesList.edit_title = res['users.edit_application_title' ];
      this.rolesManagementTranslation = res['common.rolesManagement'];
    })

    this.companies = [{ value: null, label: '' }];

    this.srvUser.getApplicationFields().subscribe(res => this.fields = res);

    if (this.fromUser) {
      this.srvCompany.getApplicationsFromUser(this.companyId).subscribe((data) => {
        data.forEach( (c) => {
          this.applications.push({ value: c.applicationId, label: c.applicationName });
        });
      })
    }

  }


  ngOnChanges(changes) {
    if (changes.selectedApplications) {
      this.selectedApplicationsClone = [];
      changes.selectedApplications.currentValue.forEach((c) => {
        let clone = {...c};
        clone.date_start = new Date(clone.date_start);
        clone.date_end = new Date(clone.date_end);
        this.selectedApplicationsClone.push(clone);
      }, this);
    }

    if (changes.selectedCompany && changes.selectedCompany.currentValue) {
      this.applications = [{
        value: null,
        label: ''
      }];

      this.srvCompany.getApplications(changes.selectedCompany.currentValue).subscribe((data) => {
        data.forEach( (c) => {
          this.applications.push({ value: c.applicationId, label: c.applicationName });
        });
      });
    }

    this.form = this.fb.group({
      'application_name': new FormControl(''),
      'date_start': new FormControl(''),
      'date_end': new FormControl('')
    });

  }

  updateElement($event) {
    let uc = {
      id: $event.id,
      user_id: this.activeUser.id,
      company_name: $event.company_name,
      company_id: $event.company_id,
      application_name: $event.application_name,
      application_id: $event.application_id,
      date_start: moment($event.date_start).format('YYYY-MM-DD'),
      date_end: moment($event.date_end).format('YYYY-MM-DD')
    };
    this.srvUser.updateUserApplication(uc).subscribe(() => {
      if (this.selectedCompany) {
        this.srvUser.getApplicationsForUserCompany(this.activeUser.id, this.selectedCompany.id).subscribe().add(() => {
          this.selectedApplicationsClone = [];
          this.srvUser.userApplications.forEach(function(c){
            let clone = Object.assign({}, c);
            clone.date_start = new Date(clone.date_start);
            clone.date_end = new Date(clone.date_end);
            this.selectedApplicationsClone.push(clone);
          }, this);
        });
      } else if (this.fromUser) {
          this.selectedApplicationsClone = [];
          this.srvUser.userApplications.forEach(function(c) {
            const appName = this.applications.find(app => c.application_name === app.value);
            let clone = Object.assign({}, c);
            if (appName) {
              clone.application_name = appName.label;
              clone.application_id = appName.value;
            }
            clone.date_start = new Date(clone.date_start);
            clone.date_end = new Date(clone.date_end);
            this.selectedApplicationsClone.push(clone);
          }, this);
      }
    }
    );
  }

  deleteElement($event) {
    this.srvUser.deleteUserApplication($event.id).subscribe().add(() => {
      this.selectedApplicationsClone.splice(this.selectedApplicationsClone.indexOf($event), 1);
      this.selectedApplicationsClone = [...this.selectedApplicationsClone];
    });
  }

  addElement(newEl) {
    let uc;
    if (this.fromUser) {
      uc = {
        id: null,
        user_id: this.activeUser.id,
        company_id: +this.companyId,
        application_id: newEl.application_name,
        date_start: moment(newEl.date_start).format('YYYY-MM-DD'),
        date_end: moment(newEl.date_end).format('YYYY-MM-DD')
      };
    } else {
      uc = {
        id: null,
        user_id: this.activeUser.id,
        company_name: this.selectedCompany.name,
        company_id: this.selectedCompany.id,
        application_name: newEl.application_name,
        application_id: newEl.application_name,
        date_start: moment(newEl.date_start).format('YYYY-MM-DD'),
        date_end: moment(newEl.date_end).format('YYYY-MM-DD')
      };
    }

    this.srvUser.createUserApplication(uc).subscribe(() => {
      if (!this.fromUser) {
        this.srvUser.getApplicationsForUserCompany(this.activeUser.id, this.selectedCompany.id).subscribe().add(() => {
          this.selectedApplicationsClone = [];
          this.srvUser.userApplications.forEach(function(c){
            let clone = Object.assign({}, c);
            clone.date_start = new Date(clone.date_start);
            clone.date_end = new Date(clone.date_end);
            this.selectedApplicationsClone.push(clone);
          }, this);
        });
      } else {
        this.srvUser.getApplicationsForUserCompany(this.activeUser.id, this.companyId).subscribe().add(() => {
          this.selectedApplicationsClone = [];
          this.srvUser.userApplications.forEach(function(c){
            let clone = Object.assign({}, c);
            clone.date_start = new Date(clone.date_start);
            clone.date_end = new Date(clone.date_end);
            this.selectedApplicationsClone.push(clone);
          }, this);
        });
      }
    });

    this.form = this.fb.group({
      'application_name': new FormControl(''),
      'date_start': new FormControl(''),
      'date_end': new FormControl('')
    });

  }

  onCustomButton() {
    this.onBackPressed.emit(true);
  }

  openDialog (event) {
    if (event) {
      this.btntraduction = 'common.edit';
      this.dialogTitle = this.dialogTitlesList.edit_title;
      this.form = this.fb.group({
        'id': event.id,
        'application_name': new FormControl(event.application_id),
        'date_start': new FormControl(event.date_start),
        'date_end': new FormControl(event.date_end)
      });
      this.setDefaultDateStart();
      this.setDefaultDateEnd();
    } else {
      this.btntraduction = 'common.save';
      this.dialogTitle = this.dialogTitlesList.add_title;
      this.form = this.fb.group({
        'application_name': new FormControl(''),
        'date_start': new FormControl(''),
        'date_end': new FormControl('')
      });
      this.defaultDateStart = null;
      this.defaultDateEnd = null;
    }
    this.showDialog = true;
  }

  saveOrUpdate(): void {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = Object.assign({}, this.form.value);

    if (newData.id == null) {
      this.addElement(newData);
    } else {
      this.updateElement(newData);
    }
    this.showDialog = false;
  }

  closeDialog () {
    this.showDialog = false;
  }

  dateSelected(value) {
    let year: string;
    let options = Array.from(document.querySelectorAll('.ui-datepicker-year option'));
    options.forEach( opt => {
      if (opt.matches(':checked')) {
        year = opt.getAttribute('value');
      }
    });
    value.setYear(year);
  }

  setDefaultDateStart() {
    if (!!this.form.controls.date_start.value) {
      this.defaultDateStart = this.form.controls.date_start.value;
    } else {
      this.defaultDateStart = this.maxDate;
    }
  }

  setDefaultDateEnd() {
    if (!!this.form.controls.date_end.value) {
      this.defaultDateEnd = this.form.controls.date_end.value;
    } else {
      this.defaultDateEnd = this.maxDate;
    }
  }

  manageRoles(application: any) {
    this.activeRolesForUserApp = [];
    this.srvRoleMS.get(application).subscribe(
      res => this.rolesForUserApp = res.list,
      err => console.error(err),
      () => {
        this.srvRoleMS.getRolesForUser(application.ms_base_url, this.activeUser.id).subscribe(
          userApps => {
            userApps.map(
              userApp => {
                this.rolesForUserApp.forEach(
                  role => {
                    if (role.id === userApp.role_id) {
                      this.activeRolesForUserApp.push(role.id);
                    }
                  }
                )
              }
            );
            this.activeRolesForUserApp = [...this.activeRolesForUserApp];
          }
        );
      }
    );
    this.selectedApplicationBaseUrl = application.ms_base_url;
    this.rolesDialogTitle = `${this.rolesManagementTranslation} / ${this.activeUser.login} / ${application.application_name}`;
    this.showRolesDialog = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/users/userApplication.component.ts